// extracted by mini-css-extract-plugin
export default {"input":"R8-z","button":"S8-z","selected":"T8-z","unavailable":"U8-z","oos":"V8-z","image":"W8-z","paperCutDisabledOverlay":"X8-z"};